module.exports = __webpack_public_path__ + "static/img/2.a982df3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newFour/2.png
// module id = 5kxx
// module chunks = 0